import { FormVM } from './FormVM';
import { action, computed, makeObservable, observable, set } from 'mobx';
import { makeMetadata, property } from '../helpers/decorators';

export class ObjectVM extends FormVM {
  constructor(...args: any[]) {
    super(...args);
    makeObservable(this);
    makeMetadata(this);
  }

  /**
   * 当前VM的data信息
   * @example
   */
  @property
  @observable
  data: object = undefined;

  /**
   * 更新当前VM的data信息
   * @param data
   */
  @action
  setData(data: object): this {
    this.data = data;
    return this;
  }

  //为兼容历史用户，未来应改为InputVM
  /**
   * Takes the factorial of `n`.
   * @example
   * 为一个单独的 "property" 设置值
   * ```ts
   * $vm.setPropertyValue("name", "xxxxx")
   * ```
   */
  @action
  setPropertyValue<V, K extends keyof V>(field: K, value: V[K]): this {
    set(this.value, field, value);
    return this;
  }

  /**
   * 获取一个属性的值
   * @example
   * 获取一个单独的 "property" 值
   * ```ts
   * $vm.getPropertyValue("name")
   * ```
   */
  getPropertyValue<V, K extends keyof V>(field: K): V[K] {
    return this.value[field];
  }

  @property
  @computed
  get dataSource() {
    return this.data;
  }

  set dataSource(data: any) {
    this.setData(data);
  }
}
